import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ToastNotificationService } from './toast-notification.service';

@Component({
  selector: 'mh-toast-notification',
  imports: [NgClass],
  templateUrl: './toast-notification.component.html',
  styleUrl: './toast-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastNotificationComponent {
  private toastService = inject(ToastNotificationService);
  toast = computed(() => this.toastService.toast());
  close = () => this.toastService.dismiss();
}
